import axios from 'axios'
import store from '@/xreports/store/index'
import { Message } from 'element-ui'
import { v4 as uuidv4 } from 'uuid'
import { getAppBaseConfig } from '@/storage/services/AppBaseConfigService'
import '@hotelcem/apis/interceptors/response/DetailQueryInterceptors'

const fatherSysAuthentication = {
  rms: 'Basic cm1zOnJtc19zZWNyZXQ=',
}
let Authorization = getAppBaseConfig().appId
if (window.location.href.includes('rms.')) {
  Authorization = fatherSysAuthentication.rms
}

class BaseAPI {
  constructor(config) {
    this.config = {
      baseURL: `${process.env.VUE_APP_APIBASEURL}/api/v1/xreports`,
      timeout: 60000,
      withCredentials: true,
      ...config,
    }
  }

  /**
   * custome error handle function
   */
  _handleError(error) {
    // 错误统一处理

    // 非200情况下
    let errorMessage = '网络异常，请稍后再试'
    /*
     * @Author: zhangxiaoyan
     * @Date: 2021-05-19 11:40
     * @Description: 接口超时错误提示
     */
    if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
      errorMessage = '查询失败，请刷新页面'
    }
    if (error.msgcode == '11011') {
      errorMessage = error.msg
    }
    Message.error({
      message: errorMessage,
    })
  }

  /**
   * Request API method
   * @param {String} method
   * @param {String} url
   * @param {Object} rBody
   */

  async fetch(method, body, reqID) {
    const reqId = uuidv4().replace(/-/g, '')

    let headers = {
      Authorization: Authorization,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      ContentType: 'application/json',
      reqId: reqID ? encodeURIComponent(reqID) : reqId,
    }
    let token = getAppBaseConfig().token || store.state.systemUser.token
    if (token) {
      headers.token = token
    }

    if (getAppBaseConfig().loginSsoToken) {
      headers.ssoToken = getAppBaseConfig().loginSsoToken || ''
    }

    return axios({
      ...this.config,
      method,
      headers,
      // include r_url, r_body
      ...body,
      // timeout: body.url.includes('data-model/aggregated') ? 100 : 60000,
      //timeout: body.url.includes('/query2') ? 100 : 60000,
    })
      .then(res => {
        // HTTPCODE 始终是 200
        // 判断 code =? 200 或者 success =? true 来验证请求是否成功
        // console.log(res)
        // console.log('body.url', body.url)
        if (!res || !res.data) {
          return Promise.reject(res || 'Empty HttpResponse')
        }
        const { code, success, data } = res.data
        if (code === 200 && success === true) {
          if (res.config.url.includes('/password/modify')) {
            return Promise.resolve(res)
          }
          return Promise.resolve(data)
        }
        if (['GENERAL_ERROR_ALERT'].includes(res.data?.msgcode)) {
          Message.error({ message: res.data.message || res.data.msg })
        }
        if (!res.data?.msg && !res.msg) {
          res.data.msg = '请求出错，请联系管理员'
        }
        if (!res.data?.message && !res.msg) {
          if (res.data.msgcode == '11011' || res.msgcode === '11011') {
            res.data.message = res.msg || res.data.msg
          } else {
            res.data.message = '请求出错，请联系管理员'
          }
        }

        // 处理请求类型是blob
        if (body.responseType && body.responseType === 'blob' && res.status === 200) {
          return Promise.resolve(res)
        }
        return Promise.reject(res.data)
      })
      .catch(error => {
        if (error?.message !== 'CANCEL') {
          console.error(`response error: url=${body.url}; reqId = ${reqId}; `)
        }
        const data = error?.code || error?.response?.data || {}
        const status = error?.status

        if (['GENERAL_ERROR_ALERT'].includes(error?.msgcode)) {
          Message.error({ message: error.message || error.msg })
        }

        if (data.code === 401 || status === 401) {
          store.dispatch('systemUser/logout')
          return Promise.reject(error)
        } else {
          if (error.isAxiosError) {
            if (
              !body.url.includes('dataCube/query2') &&
              !body.url.includes('data-model/aggregated') &&
              !body.url.includes('data/analysis/list') &&
              window.location.href.includes('xreports')
            ) {
              this._handleError(error)
            }
            // this._handleError(error)
            return Promise.reject(error)
          } else {
            return Promise.reject(error)
          }
        }
      })
  }

  /**
   * Fetch all requests used by axios.all
   * @param {Array} requests
   * @param {Function} callback 回调函数
   */
  async fetchAll(requests, callback) {
    return axios
      .all(requests)
      .then(axios.spread(callback))
      .catch(error => {
        this._handleError(error)
      })
  }

  async get(params = {}) {
    return this.fetch('GET', params)
  }

  async post(body = {}, reqID) {
    // if (body.url.includes('data-model/aggregated')) {
    //   throw { code: 400 }
    // }
    // if (body.url.includes('raw/data/analysis/list')) {
    //   throw { code: 400 }
    // }

    return this.fetch('POST', body, reqID)
  }

  async delete(params) {
    return this.fetch('DELETE', params)
  }
}

export default BaseAPI
